// import { useTheme } from "@mui/material";
import { createContext, ReactNode, useMemo, useState } from "react";

type TCThemeContext = {
  theme: "dark" | "light";
  isDark: boolean;
  setTheme: React.Dispatch<React.SetStateAction<"dark" | "light">>;
};

const initialValue: Omit<TCThemeContext, "setTheme"> = {
  theme: "dark",
  isDark: true,
};

export const CThemeContext = createContext<TCThemeContext>({
  ...initialValue,
  setTheme: () => {},
});
CThemeContext.displayName = "ThemeContext";

export const CThemeProvider = ({ children }: { children: ReactNode }) => {
  const [theme, setTheme] = useState<TCThemeContext["theme"]>("dark");
  const isDark = useMemo(() => theme === "dark", [theme]);

  return (
    <CThemeContext.Provider
      value={{
        theme,
        isDark,
        setTheme,
      }}
    >
      {children}
    </CThemeContext.Provider>
  );
};
